import { render, staticRenderFns } from "./Destiny.vue?vue&type=template&id=3bcf03f5"
import script from "./Destiny.vue?vue&type=script&lang=js"
export * from "./Destiny.vue?vue&type=script&lang=js"
import style0 from "./Destiny.vue?vue&type=style&index=0&id=3bcf03f5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports